import { NgModule } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@NgModule()
export class IconModule {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.registerIcons();
  }

  private registerIcons(): void {
    const searchIcon = `
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="8" stroke="#666" stroke-width="2"/>
        <path d="m21 21-4.35-4.35" stroke="#666" stroke-width="2" stroke-linecap="round"/>
      </svg>
    `;

    this.matIconRegistry.addSvgIconLiteral(
      'search',
      this.domSanitizer.bypassSecurityTrustHtml(searchIcon)
    );
  }
}